module.exports = __webpack_public_path__ + "static/media/carta_35.69996b1d.jpg";